/**
 * @module shaders/data
 */
export default class ShadersUniform {
    static uniforms() {
        return {
            uCanvasWidth: {
                type: "f",
                value: 0,
                typeGLSL: "float",
            },
            uCanvasHeight: {
                type: "f",
                value: 0,
                typeGLSL: "float",
            },
            uWidth: {
                type: "f",
                value: 1,
                typeGLSL: "float",
            },
            uOpacity: {
                type: "f",
                value: 1,
                typeGLSL: "float",
            },
            uTextureFilled: {
                type: "t",
                value: [],
                typeGLSL: "sampler2D",
            },

            // these uniforms are added by Avenda Health
            uMeshCenter: {
                type: "v",
                value: [0, 0, 0],
                typeGLSL: "vec3",
            },
            uDashedLength: {
                type: "f",
                value: 4.0,
                typeGLSL: "float",
            },
            uDashedGap: {
                type: "f",
                value: 2.0,
                typeGLSL: "float",
            },
            uQuadrant: {
                type: "i",
                value: 0,
                typeGLSL: "int",
            },
            uShowAxes: {
                type: "b",
                value: false,
                typeGLSL: "bool",
            },
            uDashedHighlightedOnly: {
                type: "b",
                value: false,
                typeGLSL: "bool",
            },
            uHighlightColor: {
                type: "v",
                value: [0, 0, 0],
                typeGLSL: "vec3",
            },
        };
    }
}
